var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26929 7.65392L1.26929 8.577C1.26929 11.6358 3.74894 14.1155 6.80775 14.1155M12.3462 7.65392V8.577C12.3462 11.6358 9.86656 14.1155 6.80775 14.1155M6.80775 14.1155L6.80775 17.8078M6.80775 17.8078H10.5001M6.80775 17.8078H3.11544M6.80775 11.3462C5.27834 11.3462 4.03852 10.1064 4.03852 8.577L4.03852 3.96161C4.03852 2.43221 5.27834 1.19238 6.80775 1.19238C8.33715 1.19238 9.57698 2.43221 9.57698 3.96161L9.57698 8.577C9.57698 10.1064 8.33715 11.3462 6.80775 11.3462Z",
    stroke: "#484848",
    strokeWidth: 1.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.ab493b0d5866e6bf708dd04133c50b6a.svg";
export { ForwardRef as ReactComponent };